module.exports = __webpack_public_path__ + "img/safety.2e87f80f.png";